import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export const CoachPaymentCancelPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 lg:p-10 w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold mb-4">
            <span className="text-gray-900">Game</span>
            <span className="text-green-600">Path</span>
          </h1>
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="text-xl font-bold text-gray-900">Payment Cancelled</h2>
        </div>

        <p className="text-gray-600 text-center text-sm mb-6">
          Your payment was not completed. No charges have been made to your account.
          You can try again whenever you're ready.
        </p>

        <div className="space-y-3">
          <Link
            to="/register"
            className="block w-full bg-green-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-green-700 transition-colors text-center"
          >
            Try Again
          </Link>
          <Link
            to="/login"
            className="block w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors text-center"
          >
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};
